import { FunctionComponent } from "react";

const Admin: FunctionComponent = () => (
  <svg version="1.1" width="62px" height="77px" viewBox="0 0 62.0 77.0" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="i0">
        <path d="M360,0 L360,640 L0,640 L0,0 L360,0 Z"></path>
      </clipPath>
      <clipPath id="i1">
        <path d="M19.08,0 C29.617593,0 38.16,8.54240697 38.16,19.08 C38.16,29.617593 29.617593,38.16 19.08,38.16 C8.54240697,38.16 0,29.617593 0,19.08 C0,8.54240697 8.54240697,0 19.08,0 Z"></path>
      </clipPath>
      <clipPath id="i2">
        <path d="M30.8692799,0 C43.5842799,0 56.3942799,8.9 61.1992799,27.9 C61.6146817,29.4891382 61.3604354,31.1790947 60.4958473,32.5756642 C59.6312593,33.9722337 58.2319329,34.9532942 56.6242799,35.29 C48.1253488,37.052082 39.4689527,37.9433541 30.7892799,37.9500177 C22.0544627,37.954601 13.3422072,37.0632703 4.78927993,35.29 C3.17438002,34.9572846 1.76756453,33.9746675 0.899310802,32.5729768 C0.0310570728,31.1712862 -0.22211056,29.4740613 0.199279929,27.88 C5.06427993,8.87 18.1542799,0 30.8692799,0 Z"></path>
      </clipPath>
      <clipPath id="i3">
        <path d="M38.13,0 L38.13,0.5 C38.1293671,6.37597249 35.4206385,11.9237302 30.7876385,15.5379195 C26.1546386,19.1521088 20.1144791,20.4293323 14.415,19 C5.94083387,16.861403 0.00220688608,9.23985606 0,0.5 L0,0 C0.237266708,10.3592124 8.70307082,18.6333365 19.065,18.6333365 C29.4269292,18.6333365 37.8927333,10.3592124 38.13,0 Z"></path>
      </clipPath>
      <clipPath id="i4">
        <path d="M61.4075038,0.243030454 C61.5398868,3.17062135 59.5289102,5.7825842 56.6370482,6.385 C48.1299407,8.14880702 39.4650783,9.04008831 30.7770482,9.04501772 C22.042231,9.04960102 13.3299754,8.15827027 4.77704816,6.385 C1.80498368,5.76609753 -0.236506597,3.0247904 0.0220481557,0 L0.022,0.004 L0.047352873,0.247093129 C0.350111448,2.70385905 2.13459199,4.72476919 4.53498761,5.32930408 L4.77704816,5.385 C13.3299754,7.15827027 22.042231,8.04960102 30.7770482,8.045 C39.4650783,8.04008831 48.1299407,7.14880702 56.6370482,5.385 C59.2385862,4.84258346 61.1733865,2.65347179 61.3920482,0.005 L61.392,0.005 Z"></path>
      </clipPath>
    </defs>
    <g transform="translate(-149.0 -81.0)">
      <g clipPath="url(#i0)">
        <g transform="translate(132.0 72.0)">
          <g transform="translate(28.92 9.89)">
            <g clipPath="url(#i1)">
              <polygon points="0,0 38.16,0 38.16,38.16 0,38.16 0,0" stroke="none" fill="#EBEBEB"></polygon>
            </g>
          </g>
          <g transform="translate(17.30072007137462 48.04999999999998)">
            <g clipPath="url(#i2)">
              <polygon
                points="-5.55111512e-17,0 61.3943512,0 61.3943512,37.9500353 -5.55111512e-17,37.9500353 -5.55111512e-17,0"
                stroke="none"
                fill="#EBEBEB"
              ></polygon>
            </g>
          </g>
          <g transform="translate(28.94999999999999 28.499999999999993)">
            <g clipPath="url(#i3)">
              <polygon
                points="0,0 38.13,0 38.13,19.573118 0,19.573118 0,0"
                stroke="none"
                fill="#000000"
                opacity="5.99999987%"
              ></polygon>
            </g>
          </g>
          <g transform="translate(17.28795184430726 76.955)">
            <g clipPath="url(#i4)">
              <polygon
                points="-3.46944695e-18,0 61.4136739,0 61.4136739,9.04503531 -3.46944695e-18,9.04503531 -3.46944695e-18,0"
                stroke="none"
                fill="#000000"
                opacity="5.99999987%"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Admin;
